var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"before-close":_vm.handleClose,"destroy-on-close":"","title":_vm.title,"visible":_vm.visible,"width":"55%"},on:{"close":_vm.closeModal,"update:visible":function($event){_vm.visible=$event}}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }